import UserAxios from '../Assets/Axios/Axios';

export const sendOTP = async ({ mobileNumber }) => {
  const response = await UserAxios({
    query: `mutation SendMobileCode($mobileNumber: String!) {
      sendCode(data: { mobileNumber: $mobileNumber }) {
        referenceId
        status
      }
    }`,
    variables: { mobileNumber },
  });

  if (response?.errors) {
    throw new Error(response.errors[0]?.message || 'Failed to send OTP');
  }

  const result = response?.data?.sendCode;
  return {
    data: {
      referenceId: result?.referenceId,
      status: result?.status,
    },
  };
};

export default sendOTP;
